import { Core } from './core.js'

Core.startAll();
